export function DelShareFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.232 7a4 4 0 11.731 2.306l-2.034 1.162c.195.472.303.99.303 1.532 0 .543-.108 1.06-.303 1.532l.86.491a6 6 0 11-.693 1.907l-1.385-.79a4 4 0 110-6.28l2.542-1.452a4.043 4.043 0 01-.02-.408zm1.78 8.997a1 1 0 100 2h5.983a1 1 0 100-2h-5.983z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
